




import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Checkout from './Checkout.vue';

import { buildChat, destroyChat } from '@/helpers/blipChat';

import { ICustomer } from '@/interfaces/Customer';

import { EPaymentMethodTypes } from '@/helpers/enums';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Checkout,
  }
})
export default class CheckoutContainer extends Vue {
  @AppModule.Action('prepareCheckout')
  private prepareCheckout: Function;

  @CustomerModule.Getter('isLogged')
  private customerIsLogged: boolean;

  @CustomerModule.State(state => state.customer)
  private customer: ICustomer;

  @Watch('customerIsLogged')
  whenCustomerIsLogged(isLogged: true) {
    const customer = isLogged ? this.customer : null;

    buildChat(customer);
  }

  private async mounted() {
    await this.prepareCheckout({ slug: this.$route.params.slug, payload: { payment_method: EPaymentMethodTypes.creditCard } });

    buildChat(this.customer);
  }

  private beforeDestroy() {
    destroyChat();
  }
}
